import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { LAST_SYNC_LABEL, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const StaleSyncBanner: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { FLEET_HEALTH, LAST_SYNC } = useTranslation();

    return (
        <HorizontalContainer className={`${styles.pageMeta} ${className}`} testId={testId}>
            <Wrapper className={styles.pageMetaText}>{FLEET_HEALTH}</Wrapper>

            <Wrapper className={styles.pageMetaSep}>·</Wrapper>

            <Wrapper className={styles.pageMetaText}>{LAST_SYNC}</Wrapper>

            <Wrapper className={styles.pageMetaEmph}>{LAST_SYNC_LABEL}</Wrapper>
        </HorizontalContainer>
    );
};

export default StaleSyncBanner;
